<template>
  <div
    class="text-xs-center"
    style="height: 50px"
  >
    <v-dialog
      v-model="dialog[operation]"
      width="500"
    >
      <template #activator="{ on }">
        <v-btn
          block
          :class="sellerOperations[operation].styleClass"
          :style="operation === 'exclusion' ? null : 'color: white'"
          color="#140C22"
          :outline="operation === 'exclusion' ? true : false"
          :loading="isLoading[operation]"
          :disabled="disabled"
          v-on="on"
        >
          {{ sellerOperations[operation].title }}
        </v-btn>
      </template>

      <div class="dialog px-4 py-2">
        <v-layout
          row
          align-center
        >
          <v-spacer />
          <v-btn
            icon
            small
            @click="toggleDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>
        <EditSellerSuspensionDialogContent v-if="operation === 'suspension'" />
        <EditSellerStoreRemovalDialogContent v-else-if="operation === 'changeStore'" />
        <EditSellerExclusionDialogContent v-else-if="operation === 'exclusion'" />
        <v-btn
          class="dialog__actions-btn text-capitalize"
          color="#433D4E80"
          flat
          block
          @click="toggleDialog"
        >
          Cancelar
        </v-btn>
        <v-btn
          block
          class="dialog__actions-btn text-capitalize"
          style="color: white"
          color="#140C22"
          :loading="isLoading[operation]"
          @click="sellerOperations[operation].operation"
        >
          Confirmar {{ sellerOperations[operation].confirmationLabel }}
        </v-btn>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
} from '@vue/composition-api';
import { EventBus } from '@/event-bus.js';
import EditSellerSuspensionDialogContent from './EditSellerSuspensionDialogContent.vue';
import EditSellerExclusionDialogContent from './EditSellerExclusionDialogContent.vue';
import EditSellerStoreRemovalDialogContent from './EditSellerStoreRemovalDialogContent.vue';
import { useZipperApi } from '../../composables/useZipperApi';
import phoneSanitizer from '../../resources/sanitizers/phone';

export default defineComponent({
  components: {
    EditSellerSuspensionDialogContent,
    EditSellerExclusionDialogContent,
    EditSellerStoreRemovalDialogContent,
  },
  props: {
    operation: {
      type: String,
      default: () => null,
    },
    seller: {
      type: Object,
      default: () => {},
    },
    storesToDeleteFrom: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ['save-seller'],
  setup(props, { emit, root }) {
    const dialog = ref({
      exclusion: false,
      suspension: false,
      changeStore: false,
    });
    const isLoading = ref({
      exclusion: false,
      suspension: false,
      changeStore: false,
    });
    const { client } = useZipperApi();
    const sellerRef = { ...props.seller };
    const customerId = root.$store.state.customer.id;
    const suspendSeller = async () => {
      try {
        isLoading.value = true;
        sellerRef.disabled = !sellerRef.disabled;
        sellerRef.disabledCampaign = sellerRef.disabled;
        const phoneSanitized = await phoneSanitizer(sellerRef.fullNumber);
        sellerRef.phone = Number(phoneSanitized.phone);
        sellerRef.phoneArea = Number(phoneSanitized.phoneArea);
        delete sellerRef.fullNumber;
        delete sellerRef.__typename;
        await client.chain.mutation
          .updateFieldsSeller({
            customerId,
            seller: sellerRef,
          })
          .get({ name: 1 });
        root.$router.push('/sellers');
        root.$store.dispatch('carregarPerfil', { user: root.$auth.user });
        const snackBar = {};
        snackBar.text = 'Usuário suspenso com sucesso!';
        snackBar.value = true;
        snackBar.color = '#140C22';
        snackBar.textColor = '#FFFFFF';
        EventBus.$emit('activeSnackBar', snackBar);
        isLoading.value = false;
      } catch (err) {
        const snackBar = {};
        snackBar.text = 'Ocorreu um erro, tente novamente mais tarde.';
        snackBar.value = true;
        snackBar.color = 'red';
        snackBar.textColor = '#FFFFFF';
        EventBus.$emit('activeSnackBar', snackBar);
        console.log(err);
        isLoading.value = false;
      }
    };
    const deleteSeller = async () => {
      try {
        isLoading.value = true;
        const storesToDeleteIds = props.storesToDeleteFrom.map((a) => a.id);
        const phoneSanitized = await phoneSanitizer(sellerRef.fullNumber);
        sellerRef.phone = Number(phoneSanitized.phone);
        sellerRef.phoneArea = Number(phoneSanitized.phoneArea);
        delete sellerRef.fullNumber;
        delete sellerRef.__typename;
        await client.chain.mutation
          .deleteSellersByStores({
            customerId,
            storeIds: storesToDeleteIds,
            seller: sellerRef,
          })
          .get({ name: 1 });
        root.$router.push('/sellers');
        root.$store.dispatch('carregarPerfil', { user: root.$auth.user });
        const snackBar = {};
        snackBar.text = 'Usuário excluído com sucesso!';
        snackBar.value = true;
        snackBar.color = '#140C22';
        snackBar.textColor = '#FFFFFF';
        EventBus.$emit('activeSnackBar', snackBar);
        isLoading.value = false;
      } catch (err) {
        const snackBar = {};
        snackBar.text = 'Ocorreu um erro, tente novamente mais tarde.';
        snackBar.value = true;
        snackBar.color = 'red';
        snackBar.textColor = '#FFFFFF';
        EventBus.$emit('activeSnackBar', snackBar);
        console.log(err);
        isLoading.value = false;
      }
    };
    const toggleDialog = () => {
      dialog.value[props.operation] = false;
    };
    const emitSave = () => {
      isLoading.value[props.operation] = true;
      emit('save-seller', sellerRef);
    };

    const sellerOperations = {
      suspension: {
        title: 'Suspender',
        confirmationLabel: 'Suspensão',
        operation: suspendSeller,
        styleClass: 'dialog__actions-btn text-capitalize',
      },
      changeStore: {
        title: 'Salvar',
        confirmationLabel: 'Alteração',
        operation: emitSave,
        styleClass: 'dialog__actions-btn text-capitalize mt-4 ',
      },
      exclusion: {
        title: 'Excluir',
        confirmationLabel: 'Exclusão',
        operation: deleteSeller,
        styleClass: 'dialog__actions-btn text-capitalize',
      },
    };
    return {
      suspendSeller,
      dialog,
      deleteSeller,
      emitSave,
      isLoading,
      sellerOperations,
      toggleDialog,
    };
  },
});
</script>
<style lang="scss" scoped>
.dialog {
  background: #FFFFFF;
  &__actions-btn {
    border-radius: 7.08982px;
    font-size: 16px;
    height: 41.92px !important;
  }
}
</style>
